module.exports = __webpack_public_path__ + "static/media/campaignSkeletonLg.43a0ecf5.svg";